module.exports = __webpack_public_path__ + "static/media/NO POCKETS.cae1f943.svg";